module.exports = __webpack_public_path__ + "img/error.deaf7249.png";